import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { CookieBannerModule } from '../common/cookie-banner/cookie-banner.module';
import { DataLayerModule } from '../common/datalayer/datalayer.module';
import { LanguageSelectorModule } from '../common/language-selector/language-selector.module';
import { SearchModule } from '../header/search/search.module';
import { FeedbackModule } from './feedback/feedback.module';
import { FooterColumnModule } from './footer-column/footer-column.module';
// This Module's Components
import { NgcGlobalFooter } from './global-footer.component';
import { InformationModule } from './information/information.module';
import { SocialIconsModule } from './social-icons/social-icons.module';

const NGC_FOOTER_DIRECTIVES = [NgcGlobalFooter];

@NgModule({
  declarations: [NGC_FOOTER_DIRECTIVES],
  exports: [NGC_FOOTER_DIRECTIVES],
  imports: [
    CommonModule,
    SearchModule,
    DataLayerModule,
    SocialIconsModule,
    FeedbackModule,
    FooterColumnModule,
    LanguageSelectorModule,
    InformationModule,
    CookieBannerModule
  ]
})
export class NgcFooterModule {}
